import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';


import {
  getWordpressPageBySlug
} from 'day8-react/build/content';
import {
  ComponentWrapper,
  ComponentVerticalSpacing,
  FlexForm,
  Card,
  Tabs,
  Button,
  BUTTON_TYPES,
  PhoneNumber,
  Link
} from 'day8-react/build/new-components';

import PageLayout from '../layouts/page';
import { GetStaticProps, NextPage } from 'next';
import { WpPageType } from '../globalTypes';
import wp, { sanitizeWpResponse } from '../helpers/wp';

type ContactPage = {
  page: WpPageType & {
    acf: {
      contact: {
        title: string
        text: string
      }
      phone: {
        title: string
        text: string
        openhours: string
      }
      email: {
        title: string
        text: string
        buttons: {
          button: {
            text: string
            link: string
            icon: string
          }
        }[]
      }
      chat: {
        title: string
        text: string
        button: {
          button: {
            text: string
            link: string
            icon: string
          }
        }
      }
    }
  }
}
const Contact: NextPage<ContactPage> = ({ page }) => {
  const {
    contact,
    phone,
    email,
    chat
  } = page.acf;
  const filterOptions = [
    {
      text: 'Contact form',
      comp: (
        <div>
          {contact.title && (
            <h2 className="margin-bottom-md">{contact.title}</h2>
          )}
          {contact.text && (
            <p className="margin-bottom-md">{contact.text}</p>
          )}
          <div className="text-left">
            <FlexForm template="tsw_contact_us" />
          </div>
        </div>
      )
    },
    {
      text: 'Call us',
      comp: (
        <div>
          {phone.title && (
            <h2 className="margin-bottom-md">{phone.title}</h2>
          )}
          {phone.text && (
            <p className="margin-bottom-md">{phone.text}</p>
          )}
          <PhoneNumber outline />
          <p className="margin-top-md">{phone.openhours}</p>
          <p className="margin-top-md">Alternatively, <Link href="https://calendly.com/day8/20-minute-concierge?back=1&month=2021-12" external>book in a call slot</Link> with our Customer Service team at a time convenient to you! </p>
        </div>
      )
    },
    {
      text: 'Email us',
      comp: (
        <div>
          {email.title && (
            <h2 className="margin-bottom-md">{email.title}</h2>
          )}
          {email.text && (
            <p className="margin-bottom-md">{email.text}</p>
          )}
          {email.buttons.map((button, i) => (
            <div key={i} className="max-width-xxxxs margin-auto">
              <Button
                text={button.button.text}
                className="margin-bottom-md"
                buttonType={BUTTON_TYPES.OUTLINE_PRIMARY}
                link={button.button.link}
                icon={button.button.icon}
                fullWidth
              />
            </div>
          ))}
        </div>
      )
    },
    {
      text: 'Chat',
      comp: (
        <div>
          {chat.title && (
            <h2 className="margin-bottom-md">{chat.title}</h2>
          )}
          {chat.text && (
            <p className="margin-bottom-md">{chat.text}</p>
          )}
          {chat.button.button.text && (
            <div className="max-width-xxxxs margin-auto">
              <Button
                text={chat.button.button.text}
                className="margin-bottom-md"
                buttonType={BUTTON_TYPES.OUTLINE_PRIMARY}
                link={chat.button.button.link}
                icon={chat.button.button.icon}
                fullWidth
                id="d8-js-open-chat"
              />
            </div>
          )}
        </div>
      )
    }
  ];

  return (
    <PageLayout page={page}>
      <Head>
        <title>Contact us</title>
      </Head>
      <ComponentVerticalSpacing>
        <ComponentWrapper className="max-width-xxxs margin-auto">
          <div className="text-component text-center">
            <h1>{contact.title}</h1>
            <p>{contact.text}</p>
          </div>
        </ComponentWrapper>
      </ComponentVerticalSpacing>
      <div className="tsw-contact-decoration-bg" style={{ minHeight: 600 }}>
        <ComponentVerticalSpacing>
          <ComponentWrapper className="max-width-xs margin-auto">
            <Card>
              <Tabs filterOptions={filterOptions} centerOptions>
                {({ activeFilter }: { activeFilter: number }) => (
                  <div className="text-center margin-top-lg">
                    {filterOptions[activeFilter].comp}
                  </div>
                )}
              </Tabs>
            </Card>
          </ComponentWrapper>
        </ComponentVerticalSpacing>
      </div>
    </PageLayout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  try {
    const pages: WpPageType[] = await wp.pages().slug('contact').get();
    return {
      props: {
        page: sanitizeWpResponse(pages[0])
      },
      revalidate: 300
    };
  } catch (e) {
    return { notFound: true };
  }
};

export default Contact;

